import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="documents--vat-payer-toggle"
// Toggles VAT column visibility when supplier vat_payer_type changes on the expense form.
// Observes DOM mutations to apply visibility to dynamically added item rows (e.g. build_item).
export default class extends Controller {
  static values = {
    isVatPayer: { type: Boolean, default: true }
  }

  connect() {
    this.observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.addedNodes.length > 0) {
          this.#applyVisibility()
          break
        }
      }
    })
    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  disconnect() {
    this.observer?.disconnect()
  }

  toggle(event) {
    this.isVatPayerValue = event.target.value === "standard"
  }

  isVatPayerValueChanged() {
    this.#applyVisibility()
    this.#updateControllerValues()
    this.#triggerRecalculation()
    // Tells the controls that follow the supplier's VAT status (the calculation-mode switch) that the
    // VAT columns were just shown or hidden.
    this.dispatch("change", { detail: { isVatPayer: this.isVatPayerValue } })
  }

  #applyVisibility() {
    const isVatPayer = this.isVatPayerValue

    this.element.querySelectorAll("[data-vat-column]").forEach((el) => {
      el.classList.toggle("d-none", !isVatPayer)
    })

    this.element.querySelectorAll("[data-vat-summary]").forEach((el) => {
      el.classList.toggle("d-none", !isVatPayer)
    })

    this.element.querySelectorAll("[data-vat-summary-inverse]").forEach((el) => {
      el.classList.toggle("d-none", isVatPayer)
    })

    this.element.querySelectorAll("[data-vat-subtotal-label]").forEach((el) => {
      el.classList.toggle("invoice-summary__label--bold", !isVatPayer)
    })
    this.element.querySelectorAll("[data-vat-subtotal-value]").forEach((el) => {
      el.classList.toggle("invoice-summary__value--bold", !isVatPayer)
    })

    this.element.querySelectorAll("[data-vat-colspan]").forEach((el) => {
      el.setAttribute("colspan", isVatPayer ? el.dataset.vatColspanPayer || 7 : 5)
    })
  }

  #updateControllerValues() {
    const isVatPayer = this.isVatPayerValue

    this.element.querySelectorAll("[data-documents--item-is-vat-payer-value]").forEach((el) => {
      el.setAttribute("data-documents--item-is-vat-payer-value", isVatPayer)
    })

    this.element.querySelectorAll("[data-documents--totals-calculator-is-vat-payer-value]").forEach((el) => {
      el.setAttribute("data-documents--totals-calculator-is-vat-payer-value", isVatPayer)
    })
  }

  #triggerRecalculation() {
    this.element.querySelectorAll("[data-controller~='documents--totals-calculator']").forEach((el) => {
      const controller = this.application.getControllerForElementAndIdentifier(el, "documents--totals-calculator")
      if (controller) controller.recalculate()
    })
  }
}
